import { render, staticRenderFns } from "./AgentCommissions.vue?vue&type=template&id=628e2d9a&"
import script from "./AgentCommissions.vue?vue&type=script&lang=js&"
export * from "./AgentCommissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports